// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* King of the Table panel — embedded in planning exercise cards */
.kot-settings {
  box-sizing: border-box;
}

.kot-settings--embedded {
  width: 100%;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(8, 119, 188, 0.18);
  background: linear-gradient(180deg, #f8fbfe 0%, #f3f9fe 100%);
  border-radius: 0 0 8px 8px;
}

.ex_add_box--kot {
  flex-direction: column !important;
  align-items: stretch !important;
}

.ex_add_box--kot .ex_add_box__main {
  width: 100%;
}

.ex_add_box--kot .kot-settings--embedded {
  margin-top: 0;
  border-top: 1px solid #dceaf5;
  border-radius: 0;
  padding: 10px 12px 12px;
}

.kot-settings__title-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px 0;
  color: var(--brand-primary, #0877bc);
  font-weight: 700;
  font-size: 13px;
}

.kot-settings__section {
  padding: 8px 0;
  border-bottom: 1px solid rgba(8, 119, 188, 0.1);
}

.kot-settings__section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.kot-settings__section--live {
  padding-top: 0;
}

.kot-settings__section--settings {
  padding-bottom: 0;
}

.kot-settings__section-head {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--brand-primary, #0877bc);
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 8px;
}

.kot-settings__stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.kot-settings__preview {
  padding: 4px 0 8px;
}

.kot-settings__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.kot-settings__chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #cfe3f3;
  color: #1565a8;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
}

.kot-settings__toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  background: transparent;
  border: none;
  padding: 4px 0;
  color: var(--brand-primary, #0877bc);
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  text-align: left;
}

.kot-settings__toggle-icon {
  margin-left: auto !important;
  font-size: 20px !important;
}

.kot-settings__readonly-pill {
  margin-left: auto;
  margin-right: 4px;
  font-size: 10px;
  font-weight: 600;
  color: #777;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.kot-settings__hint {
  margin: 4px 0 0;
  font-size: 12px;
  color: #777;
  line-height: 1.4;
}

.kot-settings__section-body {
  margin-top: 6px;
}

.kot-settings__table-wrap {
  overflow-x: auto;
  background: #fff;
  border: 1px solid #e3edf5;
  border-radius: 6px;
}

.kot-settings__matches {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 8px;
}

.kot-settings__match {
  border: 1px solid rgba(8, 119, 188, 0.15);
  border-radius: 8px;
  padding: 8px 10px;
  background: #fff;
}

.kot-settings__match--won {
  border-color: rgba(46, 125, 50, 0.35);
  background: #f6fbf6;
}

.kot-settings__match-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-size: 12px;
}

.kot-settings__match-state {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #5a7184;
}

.kot-settings__match-scores {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.kot-settings__match-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
}

.kot-settings__match-row--winner {
  font-weight: 700;
  color: #2e7d32;
}

.kot-settings__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.kot-settings__rules-text {
  margin-top: 8px;
}

.ex_add_box__kot-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.ex_add_box__kot-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e8f4fc;
  color: #0877bc;
  font-size: 11px;
  font-weight: 600;
}

/* Coach-enterable match cards */
.kot-settings__match--actionable {
  border-color: #90caf9;
  cursor: pointer;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.kot-settings__match--actionable:hover {
  box-shadow: 0 2px 8px rgba(8, 119, 188, 0.15);
}

.kot-settings__match--blocked {
  opacity: 0.85;
  background: #f5f8fa;
}

.kot-settings__match--setup {
  border-style: dashed;
  opacity: 0.7;
}

.kot-settings__match-cta {
  display: block;
  width: 100%;
  margin-top: 8px;
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid #90caf9;
  background: #e3f2fd;
  color: #0d47a1;
  cursor: pointer;
}

.kot-settings__match-cta:hover {
  background: #bbdefb;
}

.kot-settings__match-hint {
  margin: 6px 0 0;
  font-size: 10px;
  color: #5a7184;
  line-height: 1.3;
}

.kot-settings__match-submitted-icon {
  font-size: 14px !important;
  color: #2e7d32;
  margin-left: 4px;
}

.kot-settings__coach-hint {
  margin: 0 0 8px;
  font-size: 12px;
  color: #5a7184;
  line-height: 1.4;
}

/* Result entry dialog — above live-training chrome (coach bar / sheets ~1600) */
.kot-result-dialog__backdrop {
  position: fixed;
  inset: 0;
  z-index: 5000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  padding-left: max(16px, env(safe-area-inset-left));
  padding-right: max(16px, env(safe-area-inset-right));
  padding-top: max(16px, env(safe-area-inset-top));
  padding-bottom: max(16px, env(safe-area-inset-bottom));
}

.kot-result-dialog__sheet {
  background: #fff;
  border-radius: 14px;
  padding: 0;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  border: 1px solid #e3edf5;
  overflow: hidden;
}

/* Wizard shell (iOS-style) */
.kot-wizard__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px 10px;
  border-bottom: 1px solid #eceff1;
  background: linear-gradient(180deg, #f8fbfe 0%, #fff 100%);
}

.kot-wizard__title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: var(--brand-primary, #0877bc);
}

.kot-wizard__subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: #5a7184;
}

.kot-wizard__close {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: #f0f4f8;
  color: #5a7184;
  cursor: pointer;
}

.kot-wizard__steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 12px;
  background: #fafcfe;
  border-bottom: 1px solid #eceff1;
}

.kot-wizard__step-pill {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 72px;
  opacity: 0.45;
}

.kot-wizard__step-pill--active {
  opacity: 1;
}

.kot-wizard__step-pill--current .kot-wizard__step-num {
  background: var(--brand-primary, #0877bc);
  color: #fff;
}

.kot-wizard__step-num {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  background: #e3edf5;
  color: #5a7184;
}

.kot-wizard__step-label {
  font-size: 10px;
  font-weight: 600;
  color: #5a7184;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.kot-wizard__step-connector {
  width: 20px;
  height: 2px;
  background: #e0e0e0;
  margin-bottom: 14px;
}

.kot-wizard__step-connector--done {
  background: var(--brand-primary, #0877bc);
}

.kot-wizard__body {
  padding: 14px 16px;
  min-height: 200px;
}

.kot-wizard__hint {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 500;
  color: #5a7184;
  line-height: 1.4;
  text-align: center;
}

.kot-wizard__winner-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.kot-wizard__winner-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 52px;
  padding: 12px 16px;
  border: 2px solid #e3edf5;
  border-radius: 12px;
  background: #f4f6f8;
  color: #37474f;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.kot-wizard__winner-btn--selected {
  border-color: var(--brand-primary, #0877bc);
  background: var(--brand-primary, #0877bc);
  color: #fff;
}

.kot-wizard__winner-check {
  font-size: 20px !important;
}

.kot-wizard__dual-scores {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.kot-wizard__score-dash {
  align-self: center;
  font-size: 28px;
  font-weight: 700;
  color: #9e9e9e;
  flex-shrink: 0;
}

.kot-wizard__stepper-card {
  flex: 1 1;
  min-width: 0;
  padding: 10px 8px;
  border: 1px solid #e3edf5;
  border-radius: 12px;
  background: #fafcfe;
  text-align: center;
}

.kot-wizard__stepper-card--winner {
  border-color: #81c784;
  background: #f1f8e9;
}

.kot-wizard__stepper-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #5a7184;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kot-wizard__stepper-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.kot-wizard__stepper-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: #fff;
  color: var(--brand-primary, #0877bc);
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.kot-wizard__stepper-btn:active {
  transform: translateY(1px);
}

.kot-wizard__stepper-value {
  min-width: 36px;
  font-size: 26px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #263238;
}

.kot-wizard__loser-only {
  max-width: 220px;
  margin: 0 auto;
}

.kot-wizard__stepper-card--center {
  padding: 14px 12px;
}

.kot-wizard__hint--winner {
  font-weight: 600;
  color: #263238;
}

.kot-wizard__footer-spacer {
  flex: 1 1;
}

.kot-wizard__score-summary {
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f5f8fa;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
}

.kot-wizard__summary-win {
  font-weight: 700;
  color: #2e7d32;
}

.kot-wizard__summary-lose {
  color: #5a7184;
}

.kot-wizard__summary-dash {
  margin: 0 8px;
  font-weight: 700;
  color: #9e9e9e;
}

.kot-wizard__golden-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #ffe082;
  background: #fff8e1;
  font-size: 13px;
  font-weight: 600;
  color: #5d4037;
  cursor: pointer;
}

.kot-wizard__review-card {
  text-align: center;
  padding: 20px 16px;
  border-radius: 12px;
  border: 2px solid #81c784;
  background: #f6fbf6;
}

.kot-wizard__review-icon {
  font-size: 36px !important;
  color: #f9a825;
  margin-bottom: 8px;
}

.kot-wizard__review-winner {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 700;
  color: #1b5e20;
}

.kot-wizard__review-scores {
  margin: 0 0 4px;
  font-size: 28px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.kot-wizard__review-score-win {
  color: #2e7d32;
}

.kot-wizard__review-score-sep {
  margin: 0 8px;
  color: #9e9e9e;
}

.kot-wizard__review-loser {
  margin: 0;
  font-size: 13px;
  color: #5a7184;
}

.kot-wizard__footer {
  display: flex;
  gap: 10px;
  padding: 12px 16px 16px;
  border-top: 1px solid #eceff1;
  background: #fafcfe;
}

.kot-wizard__footer .kot-result-dialog__btn {
  flex: 1 1;
  min-height: 44px;
}

.kot-result-dialog__error {
  margin: 10px 0 0;
  font-size: 12px;
  color: #b71c1c;
}

.kot-result-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.kot-result-dialog__btn {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid transparent;
}

.kot-result-dialog__btn--ghost {
  background: #fff;
  border-color: #cfd8dc;
  color: #37474f;
}

.kot-result-dialog__btn--primary {
  background: var(--brand-primary, #0877bc);
  color: #fff;
}

.kot-result-dialog__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Coach wizard — landscape live training */
@media (orientation: landscape) {
  .kot-result-dialog__backdrop {
    padding: max(6px, env(safe-area-inset-top)) max(10px, env(safe-area-inset-right))
      max(6px, env(safe-area-inset-bottom)) max(10px, env(safe-area-inset-left));
  }

  .kot-result-dialog__sheet.kot-wizard {
    max-height: calc(100dvh - 12px);
    max-width: min(480px, 94vw);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .kot-wizard__header {
    padding: 10px 12px 8px;
    flex-shrink: 0;
  }

  .kot-wizard__title {
    font-size: 15px;
  }

  .kot-wizard__subtitle {
    font-size: 12px;
  }

  .kot-wizard__steps {
    padding: 6px 10px;
    flex-shrink: 0;
  }

  .kot-wizard__step-pill {
    min-width: 56px;
  }

  .kot-wizard__step-label {
    font-size: 9px;
  }

  .kot-wizard__body {
    padding: 10px 12px;
    min-height: unset;
    flex: 1 1;
    overflow-y: auto;
  }

  .kot-wizard__hint {
    margin-bottom: 8px;
    font-size: 12px;
  }

  .kot-wizard__winner-row {
    gap: 8px;
  }

  .kot-wizard__winner-btn {
    min-height: 42px;
    padding: 8px 12px;
    font-size: 13px;
  }

  .kot-wizard__stepper-btn {
    width: 34px;
    height: 34px;
  }

  .kot-wizard__stepper-value {
    font-size: 22px;
  }

  .kot-wizard__score-summary {
    margin-top: 8px;
    padding: 8px 10px;
    font-size: 12px;
  }

  .kot-wizard__golden-row {
    margin-top: 8px;
    padding: 8px 10px;
    font-size: 12px;
  }

  .kot-wizard__footer {
    padding: 8px 12px 10px;
    flex-shrink: 0;
  }

  .kot-wizard__footer .kot-result-dialog__btn {
    min-height: 38px;
    font-size: 13px;
  }
}

.kot-settings__player-link {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: var(--brand-primary, #0877bc);
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.kot-settings__player-link:hover {
  color: #055a8c;
}

.kot-settings__row--self {
  background: rgba(8, 119, 188, 0.06);
}

.kot-settings__you-badge {
  margin-left: 6px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
  letter-spacing: 0.02em;
}

.kot-settings__hint--inline {
  margin: 6px 0 0;
  font-size: 10px;
}

.kot-player-matches__title {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-right: 8px !important;
}

.kot-player-matches__stats {
  margin: 0 0 12px;
  font-size: 12px;
  color: #546e7a;
}

.kot-player-matches__loading {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.kot-player-matches__empty {
  margin: 0;
  font-size: 13px;
  color: #78909c;
}

.kot-player-matches__table-wrap {
  overflow-x: auto;
}

.kot-player-matches__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.kot-player-matches__table th {
  text-align: left;
  padding: 8px 6px;
  font-weight: 600;
  color: #455a64;
  border-bottom: 1px solid #e3edf5;
  white-space: nowrap;
}

.kot-player-matches__table td {
  padding: 8px 6px;
  border-bottom: 1px solid #f0f4f8;
  vertical-align: middle;
}

.kot-player-matches__score {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

.kot-player-matches__outcome {
  font-weight: 600;
  font-size: 11px;
}

.kot-player-matches__outcome--win {
  color: #2e7d32;
}

.kot-player-matches__outcome--loss {
  color: #c62828;
}

.kot-player-matches__outcome--pending {
  color: #f57c00;
}
`, "",{"version":3,"sources":["webpack://./src/components/KotSettings.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;EAC7C,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,oDAAoD;EACpD,gDAAgD;EAChD,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE;IACE;gFAC4E;EAC9E;;EAEA;IACE,+BAA+B;IAC/B,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* King of the Table panel — embedded in planning exercise cards */\n.kot-settings {\n  box-sizing: border-box;\n}\n\n.kot-settings--embedded {\n  width: 100%;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(8, 119, 188, 0.18);\n  background: linear-gradient(180deg, #f8fbfe 0%, #f3f9fe 100%);\n  border-radius: 0 0 8px 8px;\n}\n\n.ex_add_box--kot {\n  flex-direction: column !important;\n  align-items: stretch !important;\n}\n\n.ex_add_box--kot .ex_add_box__main {\n  width: 100%;\n}\n\n.ex_add_box--kot .kot-settings--embedded {\n  margin-top: 0;\n  border-top: 1px solid #dceaf5;\n  border-radius: 0;\n  padding: 10px 12px 12px;\n}\n\n.kot-settings__title-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 12px 0;\n  color: var(--brand-primary, #0877bc);\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.kot-settings__section {\n  padding: 8px 0;\n  border-bottom: 1px solid rgba(8, 119, 188, 0.1);\n}\n\n.kot-settings__section:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.kot-settings__section--live {\n  padding-top: 0;\n}\n\n.kot-settings__section--settings {\n  padding-bottom: 0;\n}\n\n.kot-settings__section-head {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--brand-primary, #0877bc);\n  font-weight: 600;\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n\n.kot-settings__stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.kot-settings__preview {\n  padding: 4px 0 8px;\n}\n\n.kot-settings__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.kot-settings__chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #fff;\n  border: 1px solid #cfe3f3;\n  color: #1565a8;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.kot-settings__toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  background: transparent;\n  border: none;\n  padding: 4px 0;\n  color: var(--brand-primary, #0877bc);\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.kot-settings__toggle-icon {\n  margin-left: auto !important;\n  font-size: 20px !important;\n}\n\n.kot-settings__readonly-pill {\n  margin-left: auto;\n  margin-right: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #777;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.kot-settings__hint {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: #777;\n  line-height: 1.4;\n}\n\n.kot-settings__section-body {\n  margin-top: 6px;\n}\n\n.kot-settings__table-wrap {\n  overflow-x: auto;\n  background: #fff;\n  border: 1px solid #e3edf5;\n  border-radius: 6px;\n}\n\n.kot-settings__matches {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 8px;\n}\n\n.kot-settings__match {\n  border: 1px solid rgba(8, 119, 188, 0.15);\n  border-radius: 8px;\n  padding: 8px 10px;\n  background: #fff;\n}\n\n.kot-settings__match--won {\n  border-color: rgba(46, 125, 50, 0.35);\n  background: #f6fbf6;\n}\n\n.kot-settings__match-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 6px;\n  font-size: 12px;\n}\n\n.kot-settings__match-state {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #5a7184;\n}\n\n.kot-settings__match-scores {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.kot-settings__match-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.kot-settings__match-row--winner {\n  font-weight: 700;\n  color: #2e7d32;\n}\n\n.kot-settings__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.kot-settings__rules-text {\n  margin-top: 8px;\n}\n\n.ex_add_box__kot-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.ex_add_box__kot-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #e8f4fc;\n  color: #0877bc;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n/* Coach-enterable match cards */\n.kot-settings__match--actionable {\n  border-color: #90caf9;\n  cursor: pointer;\n  transition: box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.kot-settings__match--actionable:hover {\n  box-shadow: 0 2px 8px rgba(8, 119, 188, 0.15);\n}\n\n.kot-settings__match--blocked {\n  opacity: 0.85;\n  background: #f5f8fa;\n}\n\n.kot-settings__match--setup {\n  border-style: dashed;\n  opacity: 0.7;\n}\n\n.kot-settings__match-cta {\n  display: block;\n  width: 100%;\n  margin-top: 8px;\n  padding: 6px 8px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: 1px solid #90caf9;\n  background: #e3f2fd;\n  color: #0d47a1;\n  cursor: pointer;\n}\n\n.kot-settings__match-cta:hover {\n  background: #bbdefb;\n}\n\n.kot-settings__match-hint {\n  margin: 6px 0 0;\n  font-size: 10px;\n  color: #5a7184;\n  line-height: 1.3;\n}\n\n.kot-settings__match-submitted-icon {\n  font-size: 14px !important;\n  color: #2e7d32;\n  margin-left: 4px;\n}\n\n.kot-settings__coach-hint {\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: #5a7184;\n  line-height: 1.4;\n}\n\n/* Result entry dialog — above live-training chrome (coach bar / sheets ~1600) */\n.kot-result-dialog__backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 5000;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  box-sizing: border-box;\n  padding-left: max(16px, env(safe-area-inset-left));\n  padding-right: max(16px, env(safe-area-inset-right));\n  padding-top: max(16px, env(safe-area-inset-top));\n  padding-bottom: max(16px, env(safe-area-inset-bottom));\n}\n\n.kot-result-dialog__sheet {\n  background: #fff;\n  border-radius: 14px;\n  padding: 0;\n  max-width: 420px;\n  width: 100%;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e3edf5;\n  overflow: hidden;\n}\n\n/* Wizard shell (iOS-style) */\n.kot-wizard__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px 10px;\n  border-bottom: 1px solid #eceff1;\n  background: linear-gradient(180deg, #f8fbfe 0%, #fff 100%);\n}\n\n.kot-wizard__title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--brand-primary, #0877bc);\n}\n\n.kot-wizard__subtitle {\n  margin: 2px 0 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #5a7184;\n}\n\n.kot-wizard__close {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: #f0f4f8;\n  color: #5a7184;\n  cursor: pointer;\n}\n\n.kot-wizard__steps {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 10px 12px;\n  background: #fafcfe;\n  border-bottom: 1px solid #eceff1;\n}\n\n.kot-wizard__step-pill {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  min-width: 72px;\n  opacity: 0.45;\n}\n\n.kot-wizard__step-pill--active {\n  opacity: 1;\n}\n\n.kot-wizard__step-pill--current .kot-wizard__step-num {\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n}\n\n.kot-wizard__step-num {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  font-size: 11px;\n  font-weight: 700;\n  background: #e3edf5;\n  color: #5a7184;\n}\n\n.kot-wizard__step-label {\n  font-size: 10px;\n  font-weight: 600;\n  color: #5a7184;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.kot-wizard__step-connector {\n  width: 20px;\n  height: 2px;\n  background: #e0e0e0;\n  margin-bottom: 14px;\n}\n\n.kot-wizard__step-connector--done {\n  background: var(--brand-primary, #0877bc);\n}\n\n.kot-wizard__body {\n  padding: 14px 16px;\n  min-height: 200px;\n}\n\n.kot-wizard__hint {\n  margin: 0 0 12px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #5a7184;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.kot-wizard__winner-row {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.kot-wizard__winner-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 52px;\n  padding: 12px 16px;\n  border: 2px solid #e3edf5;\n  border-radius: 12px;\n  background: #f4f6f8;\n  color: #37474f;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.kot-wizard__winner-btn--selected {\n  border-color: var(--brand-primary, #0877bc);\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n}\n\n.kot-wizard__winner-check {\n  font-size: 20px !important;\n}\n\n.kot-wizard__dual-scores {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n}\n\n.kot-wizard__score-dash {\n  align-self: center;\n  font-size: 28px;\n  font-weight: 700;\n  color: #9e9e9e;\n  flex-shrink: 0;\n}\n\n.kot-wizard__stepper-card {\n  flex: 1;\n  min-width: 0;\n  padding: 10px 8px;\n  border: 1px solid #e3edf5;\n  border-radius: 12px;\n  background: #fafcfe;\n  text-align: center;\n}\n\n.kot-wizard__stepper-card--winner {\n  border-color: #81c784;\n  background: #f1f8e9;\n}\n\n.kot-wizard__stepper-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #5a7184;\n  margin-bottom: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.kot-wizard__stepper-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.kot-wizard__stepper-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 10px;\n  background: #fff;\n  color: var(--brand-primary, #0877bc);\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.kot-wizard__stepper-btn:active {\n  transform: translateY(1px);\n}\n\n.kot-wizard__stepper-value {\n  min-width: 36px;\n  font-size: 26px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: #263238;\n}\n\n.kot-wizard__loser-only {\n  max-width: 220px;\n  margin: 0 auto;\n}\n\n.kot-wizard__stepper-card--center {\n  padding: 14px 12px;\n}\n\n.kot-wizard__hint--winner {\n  font-weight: 600;\n  color: #263238;\n}\n\n.kot-wizard__footer-spacer {\n  flex: 1;\n}\n\n.kot-wizard__score-summary {\n  margin-top: 14px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #f5f8fa;\n  text-align: center;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.kot-wizard__summary-win {\n  font-weight: 700;\n  color: #2e7d32;\n}\n\n.kot-wizard__summary-lose {\n  color: #5a7184;\n}\n\n.kot-wizard__summary-dash {\n  margin: 0 8px;\n  font-weight: 700;\n  color: #9e9e9e;\n}\n\n.kot-wizard__golden-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #ffe082;\n  background: #fff8e1;\n  font-size: 13px;\n  font-weight: 600;\n  color: #5d4037;\n  cursor: pointer;\n}\n\n.kot-wizard__review-card {\n  text-align: center;\n  padding: 20px 16px;\n  border-radius: 12px;\n  border: 2px solid #81c784;\n  background: #f6fbf6;\n}\n\n.kot-wizard__review-icon {\n  font-size: 36px !important;\n  color: #f9a825;\n  margin-bottom: 8px;\n}\n\n.kot-wizard__review-winner {\n  margin: 0 0 8px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #1b5e20;\n}\n\n.kot-wizard__review-scores {\n  margin: 0 0 4px;\n  font-size: 28px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.kot-wizard__review-score-win {\n  color: #2e7d32;\n}\n\n.kot-wizard__review-score-sep {\n  margin: 0 8px;\n  color: #9e9e9e;\n}\n\n.kot-wizard__review-loser {\n  margin: 0;\n  font-size: 13px;\n  color: #5a7184;\n}\n\n.kot-wizard__footer {\n  display: flex;\n  gap: 10px;\n  padding: 12px 16px 16px;\n  border-top: 1px solid #eceff1;\n  background: #fafcfe;\n}\n\n.kot-wizard__footer .kot-result-dialog__btn {\n  flex: 1;\n  min-height: 44px;\n}\n\n.kot-result-dialog__error {\n  margin: 10px 0 0;\n  font-size: 12px;\n  color: #b71c1c;\n}\n\n.kot-result-dialog__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.kot-result-dialog__btn {\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.kot-result-dialog__btn--ghost {\n  background: #fff;\n  border-color: #cfd8dc;\n  color: #37474f;\n}\n\n.kot-result-dialog__btn--primary {\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n}\n\n.kot-result-dialog__btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Coach wizard — landscape live training */\n@media (orientation: landscape) {\n  .kot-result-dialog__backdrop {\n    padding: max(6px, env(safe-area-inset-top)) max(10px, env(safe-area-inset-right))\n      max(6px, env(safe-area-inset-bottom)) max(10px, env(safe-area-inset-left));\n  }\n\n  .kot-result-dialog__sheet.kot-wizard {\n    max-height: calc(100dvh - 12px);\n    max-width: min(480px, 94vw);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .kot-wizard__header {\n    padding: 10px 12px 8px;\n    flex-shrink: 0;\n  }\n\n  .kot-wizard__title {\n    font-size: 15px;\n  }\n\n  .kot-wizard__subtitle {\n    font-size: 12px;\n  }\n\n  .kot-wizard__steps {\n    padding: 6px 10px;\n    flex-shrink: 0;\n  }\n\n  .kot-wizard__step-pill {\n    min-width: 56px;\n  }\n\n  .kot-wizard__step-label {\n    font-size: 9px;\n  }\n\n  .kot-wizard__body {\n    padding: 10px 12px;\n    min-height: unset;\n    flex: 1;\n    overflow-y: auto;\n  }\n\n  .kot-wizard__hint {\n    margin-bottom: 8px;\n    font-size: 12px;\n  }\n\n  .kot-wizard__winner-row {\n    gap: 8px;\n  }\n\n  .kot-wizard__winner-btn {\n    min-height: 42px;\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n\n  .kot-wizard__stepper-btn {\n    width: 34px;\n    height: 34px;\n  }\n\n  .kot-wizard__stepper-value {\n    font-size: 22px;\n  }\n\n  .kot-wizard__score-summary {\n    margin-top: 8px;\n    padding: 8px 10px;\n    font-size: 12px;\n  }\n\n  .kot-wizard__golden-row {\n    margin-top: 8px;\n    padding: 8px 10px;\n    font-size: 12px;\n  }\n\n  .kot-wizard__footer {\n    padding: 8px 12px 10px;\n    flex-shrink: 0;\n  }\n\n  .kot-wizard__footer .kot-result-dialog__btn {\n    min-height: 38px;\n    font-size: 13px;\n  }\n}\n\n.kot-settings__player-link {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: var(--brand-primary, #0877bc);\n  font-weight: 600;\n  cursor: pointer;\n  text-align: left;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.kot-settings__player-link:hover {\n  color: #055a8c;\n}\n\n.kot-settings__row--self {\n  background: rgba(8, 119, 188, 0.06);\n}\n\n.kot-settings__you-badge {\n  margin-left: 6px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n  letter-spacing: 0.02em;\n}\n\n.kot-settings__hint--inline {\n  margin: 6px 0 0;\n  font-size: 10px;\n}\n\n.kot-player-matches__title {\n  display: flex !important;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding-right: 8px !important;\n}\n\n.kot-player-matches__stats {\n  margin: 0 0 12px;\n  font-size: 12px;\n  color: #546e7a;\n}\n\n.kot-player-matches__loading {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n.kot-player-matches__empty {\n  margin: 0;\n  font-size: 13px;\n  color: #78909c;\n}\n\n.kot-player-matches__table-wrap {\n  overflow-x: auto;\n}\n\n.kot-player-matches__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.kot-player-matches__table th {\n  text-align: left;\n  padding: 8px 6px;\n  font-weight: 600;\n  color: #455a64;\n  border-bottom: 1px solid #e3edf5;\n  white-space: nowrap;\n}\n\n.kot-player-matches__table td {\n  padding: 8px 6px;\n  border-bottom: 1px solid #f0f4f8;\n  vertical-align: middle;\n}\n\n.kot-player-matches__score {\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n}\n\n.kot-player-matches__outcome {\n  font-weight: 600;\n  font-size: 11px;\n}\n\n.kot-player-matches__outcome--win {\n  color: #2e7d32;\n}\n\n.kot-player-matches__outcome--loss {\n  color: #c62828;\n}\n\n.kot-player-matches__outcome--pending {\n  color: #f57c00;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
